module.exports = __webpack_public_path__ + "ef305858d0c857201306ef8a79348777.png";